import { routes as queueRoutes } from "./patients/routes";
import { routes as resultsRoutes } from "./record/routes";
import { routes as completedInvestigations } from "../completed-investigations/routes";
import { routes as pastQueueRoutes } from "./past-queue/routes";
import { routes as reportingQueueRoutes } from "./reporting-queue/routes";

export const routes = [
    ...queueRoutes(),
    ...resultsRoutes(),
    ...completedInvestigations(`radiology`),
    ...pastQueueRoutes(),
    ...reportingQueueRoutes(),
];
